import { Component,inject } from '@angular/core';
import { LoadingService } from '../../../core/services/common/loading.service';

@Component({
  selector: 'app-loader',
  imports: [],
  standalone: true,
  templateUrl: './app-loader.html',
  styleUrl: './app-loader.scss',
})
export class AppLoader {
readonly loadingService = inject(LoadingService);
}
